/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from "jquery";
import _ from "underscore";
import axios from "axios";
import store from "../state/store";

store.on("tutoring_jobs:show", function (tutoring_job_id) {
  $.ajax({
    url: `/api/sales/tutoring_jobs/${tutoring_job_id}`,
    type: "GET",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      let lesson_plan;
      if (
        (lesson_plan = _.first(
          _.select(
            store.get().enquiry.lesson_plans,
            (lesson_plan) => lesson_plan.tutoring_job_id === tutoring_job_id,
          ),
        ))
      ) {
        lesson_plan.set({ tutoring_job: data });
        return store.get().set({ tutor_proposals: data.tutor_proposals });
      }
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("tutoring_jobs:update", function (tutoring_job_id, params) {
  if (params == null) {
    params = {};
  }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${tutoring_job_id}`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(params),
    success: (data) => {
      let lesson_plan;
      if (
        (lesson_plan = _.first(
          _.select(
            store.get().enquiry.lesson_plans,
            (lesson_plan) => lesson_plan.tutoring_job_id === tutoring_job_id,
          ),
        ))
      ) {
        return lesson_plan.set({ tutoring_job: data });
      }
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("tutoring_jobs:update_note", function (tutoring_job_id, params) {
  $.ajax({
    url: `/api/sales/tutoring_jobs/${tutoring_job_id}/update_note`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(params),
    success: (data) => {
      let lesson_plan;

      if (
        (lesson_plan = _.first(
          _.select(
            store.get().enquiry.lesson_plans,
            (lesson_plan) => lesson_plan.tutoring_job_id === tutoring_job_id,
          ),
        ))
      ) {
        let h = {};
        h[params.name] = params.value;
        lesson_plan.tutoring_job.notes.set(h);
      }
    },
    error: (data) => {
      toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("tutoring_jobs:update_settings", function (tutoring_job_id, settings) {
  if (settings == null) {
    settings = {};
  }
  const params = { settings };

  return axios
    .put(`/api/sales/tutoring_jobs/${tutoring_job_id}/update_settings`, params)
    .then(function (response) {
      let lesson_plan;
      if (
        (lesson_plan = _.first(
          _.select(
            store.get().enquiry.lesson_plans,
            (lesson_plan) => lesson_plan.tutoring_job_id === tutoring_job_id,
          ),
        ))
      ) {
        return lesson_plan.set({ tutoring_job: response.data });
      }
    })
    .catch((error) => handleError(error));
});

store.on("tutoring_job:tutor_search:start", function () {
  const params = store.get().ui.tutor_searcher;
  const { tutoring_job_id } = params;

  return $.ajax({
    url: `/api/sales/tutoring_jobs/${tutoring_job_id}/tutor_searches/start`,
    type: "POST",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(params),
    success: (data) => {
      store.emit("tutoring_jobs:show", tutoring_job_id);
      return store.emit("ui:tutor_searcher:close");
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("tutoring_job:tutor_search:stop", function () {
  const params = store.get().ui.tutor_searcher;
  const { tutoring_job_id } = params;

  return $.ajax({
    url: `/api/sales/tutoring_jobs/${tutoring_job_id}/tutor_searches/stop`,
    type: "POST",
    dataType: "json",
    contentType: "application/json",
    success: (data) => {
      store.emit("tutoring_jobs:show", tutoring_job_id);
      return store.emit("ui:tutor_searcher:close");
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

store.on("tutoring_jobs:request_placement", function () {
  const state = store.get().ui.request_placement;
  const tutoring_job_id = state.tutoring_job_id;
  const payload = {
    tutoring_job_id,
    request_tutor_search: state.request_tutor_search,
    position_ids: state.position_ids,
    placement_manager_id: state.placement_manager_id || null,
    reserved_for_minutes: state.placement_manager_id ? state.reserved_for_minutes : null,
  };

  return $.ajax({
    url: `/api/sales/tutoring_jobs/${tutoring_job_id}/request_placement`,
    type: "PUT",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: (data) => {
      store.emit("tutoring_jobs:show", tutoring_job_id);
      return store.emit("ui:request_placement:close");
    },
    error: (data) => {
      return toastr.error(
        __guard__(
          data != null ? data.responseJSON : undefined,
          (x) => x.custom_error_message,
        ) || "something went wrong",
      );
    },
  });
});

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined;
}
